<template>
	<div>
		<div class="list-btn">
			<!-- <Button type="primary" @click="ret">返回</Button> -->
		</div>
		<div>
			 <Tag color="blue">金额：{{totalMoney}}元</Tag>
			 <Tag color="blue">订单数：{{totalOrderNumber}}</Tag>
			 <Tag color="blue">销售量：{{totalCommNumber}}</Tag>
			  <DatePicker type="date"  placeholder="请选择日期" style="width: 200px" v-model="shijian1" @on-change="onchange"> </DatePicker>
			  
			  <Select v-model="query.macIds" placeholder="请选择设备" multiple style="width:300px" max-tag-count='2' filterable='true' @on-change="onchangeSousuo">
			          <Option v-for="item in macs" :value="item.value" :key="item.value">{{ item.label }}</Option>
			  </Select>
			  <Button type="info" @click="daochu">导出</Button>
		</div>
		<div style="display: flex;width: 90%;justify-content: center;">{{shijian}}  销售曲线图</div>
		<Row>
			<Card shadow>
				<example v-if="hackResetZXT" style="height: 310px;" :series='zxt.series' :xAxisData="zxt.xAxisData" :name="zxt.name" :end="zxt.end" />
			
			</Card>
		</Row>
		<Table border ref="selection" :columns="columns12" :data="data6" @on-selection-change="selection" :loading="loading">
		
			<template slot-scope="{ row, index }" slot="action">
				<!-- <Button type="primary" size="small" style="margin-right: 5px" @click="xiangqing(row)">详情</Button> -->
			</template>
		</Table>
	</div>
</template>

<script>
	import InforCard from '../../../comm/info-card/infor-card.vue'
	import CountTo from '../../../comm/count-to/count-to.vue'
	import {
		ChartPie,
		ChartBar
	} from '../../../comm/charts'
	import Example from './example.vue'
	import http from '../../../../http/http.js'
	let _this = this
	export default {
		name: 'home',
		components: {
			InforCard,
			CountTo,
			ChartPie,
			ChartBar,
			Example
		},
		created() {
			_this = this
			console.log(_this.$route.query.year)
			if(_this.$route.query.year!=undefined){
				this.query.year=_this.$route.query.year
				this.query.month=_this.$route.query.month
				this.query.day=_this.$route.query.day
				this.shijian=this.query.year+"年-"+this.query.month+"月"+this.query.day+"日"
				this.shijian1=this.query.year+"年-"+this.query.month+"月"+this.query.day+"日"
			}else{
				var date = new Date();
				let year=parseInt(date.getFullYear()); //获取完整的年份(4位)
				let month=parseInt(date.getMonth())+1; //获取当前月份(0-11,0代表1月)
				let day=parseInt(date.getDate()); //获取当前日(1-31)
				this.shijian=year+"年-"+month+"月-"+day+"日"
				this.shijian1=year+"年-"+month+"月-"+day+"日"
				
				this.query.year=year
				this.query.month=month
				this.query.day=day
			}
			_this.queryMacs()
			_this.queryDay()
		},
		data() {
			return {
				allList:[],
				loading:false,
				shijian:'',
				totalMoney:0,
				totalOrderNumber:0,
				totalCommNumber:0,
				hackResetZXT: false,
				zxt: {
					series: [{
						name: '销售额(元)',
						type: 'line',
						stack: '总量',
						// areaStyle: {
						// 	normal: {
						// 		color: '#2176FA'
						// 	}
						// },
						data: []
					}],
					end: 100, //显示的数据百分比
					name: '今日销售情况',
					xAxisData: [
					]
				},
				macs:[],
				query:{
					year: 2020,
					month: 9,
					day:8,
					macIds:[],
				},
				columns12: [
					{
							title: 'id',
							key: 'id'
					},
					{
							title: '订单标识',
							key: 'orderCode'
					},
					{
						title: '商品名称',
						key: 'commodityName'
					},
					{
						title: '商品类型',
						key: 'commodityTypeName'
					},
					{
						title: '货道',
						key: 'macLeaveFactoryAisleNumber'
					},
					{
						title: '应出数量',
						key: 'number'
					},
					{
						title: '实际出货量',
						key: 'shipmentNumber'
					},
					{
						title: '单价(元)',
						key: 'sellPrice',
						render: (h, params) => {
							return h("div",params.row.sellPrice.toFixed(2))
						}
					},
					{
						title: '总金额(元)',
						key: 'sellPrices',
						render: (h, params) => {
							return h("div",(params.row.sellPrice*params.row.number).toFixed(2))
						}
					},
					
					// {
					// 	title: '订单状态',
					// 	key: 'orderState',
					// 	width: 100,
					// 	render: (h, params) => {
					// 		if(params.row.number==params.row.shipmentNumber){
					// 			return h("div",{style: {color: '#00ff00'}},"正常")
					// 		}else{
					// 			return h("div",{style: {color: 'red'}},"异常")
					// 		}
					// 	}
					// },
					{
						title: '指令是否下发',
						key: 'isShipment',
						width: 100,
						render: (h, params) => {
							if(params.row.isShipment){
								return h("div",{
									style: {
									             color: '#19be6b'
									          }
								},"指令已下发")
							}else{
								return h("div",{
									style: {
									             color: '#ed4014'
									          }
								},"指令未下发")
							}
							
						}
					},
					{
						title: '出货结果',
						key: 'result',
						width: 100,
						render: (h, params) => {
							if(params.row.result=='暂无'){
								return h("div",{
									style: {
									             color: '#ff9900'
									          }
								},"暂无")
							}else if(params.row.number==params.row.shipmentNumber){
								return h("div",{
									style: {
									             color: '#19be6b'
									          }
								},"正常")
							}else{
								return h("div",{
									style: {
									             color: '#ed4014'
									          }
								},"异常")
							}
						}
					},
					{
						title: '是否退款',
						key: 'isrefundString',
						width: 100,
						render: (h, params) => {
							/*switch (params.row.isrefund){
								case '1':
								    return h("div",{style: {color: '#ebe409'}},"正在退款")
									break;
								case '2':
								
								    return h("div",{style: {color: 'red'}},"已退款")
									break;
								default:
								    return h("div","")
									break;
							}*/
							if(params.row.refundMoney == 0 || null){
								 return h("div",{style: {color: 'red'}},"")
							}else{
								return h("div",{style: {color: 'ebe409'}},"正在退款")
							}	
						}
					},
					{
						title: '已退款金额',
						key: 'refundMoney',
						render: (h, params) => {
							return h("div",params.row.refundMoney.toFixed(2))
						}
					},{
						title: '时间',
						key: 'createdTime'
					},
					// {
					// 	title: '操作',
					// 	slot: 'action',
					// 	width: 120,
					// 	align: 'center'
					// }
				],
				data6: [
				],
				
			}
		},

		methods: {
			onchangeSousuo(){
				
				let _this=this
				_this.query.page=0
				_this.queryDay()
			},
			queryMacs(){
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fac/mac/leave/factory/page/oper',
				    data: {page:0,size:1000},
					_this: _this,
					success: function(data) {
						let items = data.macFaultDetailss.content
						for (let i = 0; i < items.length; i++) {
							let a={
								value: '',
								label: ''
							}
							a.value=items[i].id
							a.label=items[i].id+"-"+items[i].address
							_this.macs.push(a)
						}
					}
				  })
			},
			daochu(){
				console.log(this.allList)
				let _this=this
				/*_this.$refs.selection.exportCsv({	
				});*/
				require.ensure([],()=>{
							const {export_json_to_excel}=require('../../../../../excel/Export2Excel.js')
							const tHeader = ['id','订单标识','商品名称','商品类型','货道','应出数量','实际出货量','单价(元)',
							'总金额','指令是否下发','出货结果','是否退款','已退款金额','时间']
							const filterVal = ['id','orderCode','commodityName','commodityTypeName','macLeaveFactoryAisleNumber',
							'number','shipmentNumber','sellPrice','sellPrices','isShipment','result','isrefundString','refundMoney','createdTime']
							let listfix = []
							this.allList.forEach((item,index)=>{
							if(item.commodityName){
								let obj={
								'id':item.id,
								'orderCode':item.orderCode,
								'commodityName':item.commodityName,
								'commodityTypeName':item.commodityTypeName,
								'macLeaveFactoryAisleNumber':item.macLeaveFactoryAisleNumber,
								'number':item.number,
								'shipmentNumber':item.shipmentNumber,
								'sellPrice':item.sellPrice,
								'sellPrices':item.sellPrice*item.number,
								'isShipment':item.isShipment==true? "指令已下发" : "" ||item.isShipment==false? "指令未下发" : "",
								'result':item.result == "暂无"? "暂无":"" || item.number == item.shipmentNumber? "正常" :"" ||"异常",
								'isrefundString':item.refundMoney != null||""||0? "已退款":"正在退款",
								'refundMoney':item.refundMoney,
								'createdTime':item.createdTime,
								}
								listfix.push(obj)
							}
							})
							const list =[...listfix]
							const data = _this.formatJson(filterVal,list)
							export_json_to_excel(tHeader,data,'设备上的数据')
						})
				 
			},
			formatJson(filterVal, jsonData) { //这里必须写
          			return jsonData.map(v => filterVal.map(j => v[j]))
      },
			ret() { //返回上一页
				this.$router.go(-1)
			},
			xiangqing(item){
				this.$router.push({
					name: 'oper/finance/list',
					query: {
						orderId: item.id,
					}
				})
			},
			onchange(a,b){
					this.shijian=a
					
					this.query.year=a.split('-')[0]
					this.query.month=a.split('-')[1]
					this.query.day=a.split('-')[2]
					this.queryDay()
				
			},
			queryDay() {
				_this.loading=true
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/fin/report/comm/oper/operDayFin',
					data: _this.query,
					_this: _this,
					success: function(data) {
						_this.allList = data.list
						_this.loading=false
						_this.totalMoney=data.totalMoney.toFixed(2)
						_this.totalOrderNumber=data.totalOrderNumber
						_this.totalCommNumber=data.totalCommNumber
						let list=data.list
						_this.data6 =list
						console.log(list)
						_this.zxt.xAxisData=[]
						_this.zxt.series[0].data=[]
						for (var i = 0; i < list.length; i++) {
							let item=list[i]
							_this.zxt.xAxisData.push(item.createdTime.substring(11,19))
							_this.zxt.series[0].data.push(item.money)
						}
						
						if(list.length>0){
							let a=50/list.length
							if(a<1){
								_this.zxt.end=list.length*a
							}
						}
						_this.hackResetZXT = false
						_this.$nextTick(() => {
							_this.hackResetZXT = true
						})
					}
					//假设后台需要的是表单数据这里你就可以更改
				})
			}
		},
		//修改首页的meta值，false时再次进入页面会重新请求数据。
		beforeRouteLeave(to, from, next) {
			if(to.name=='oper/baobiao/list/month'){
				
				from.meta.keepAlive = false;
				this.$destroy(); //销毁B的实例
				next();//当我们前进的不是C时我们让B页面刷新
			}else{
				to.meta.keepAlive=true;
				//from.meta.keepAlive=true;//当我们进入到C时开启B的缓存
				
				next()
			}
		}, 
	}
</script>

<style lang="less">
	.count-style {
		font-size: 50px;
	}
</style>



// WEBPACK FOOTER //
// src/components/oper/finance/baobiao/day.vue